"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumPricingZoneSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.SourgumPricingZoneSchema = {
    name: 'sourgum-pricing-zone',
    alias: 'Sourgum Pricing Zone',
    shortName: 'Pricing Zone',
    applications: ['aap'],
    filterDocuments(document) {
        return document.type === 'HAULER_BILLING';
    },
    returnType: {
        aap: transport_types_1.Pricing.PricingTransport,
    },
    searchableAttributes: [
        {
            field: 'zoneName',
            alias: 'Zone Name',
            shortName: 'Zone',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            type: 'BOOLEAN',
            field: 'haulerApproved',
            alias: 'Hauler Approved',
            shortName: 'Hauler Approved',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            type: 'BOOLEAN',
            field: 'sourgumApproved',
            alias: 'Sourgum Approved',
            shortName: 'Sourgum Approved',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            type: 'STRING',
            field: 'type',
            alias: 'Pricing Type',
            shortName: 'Type',
            allowsMultipleValues: false,
            allowedOperators: 'ALL',
            options: transport_types_1.Pricing.PricingTypes.filter((type) => type !== 'HAULER_BILLING').map((type) => ({
                value: type,
                label: transport_types_1.Pricing.ZoneTypeLabelSAP[type],
            })),
        },
        {
            type: 'STRING',
            field: 'state',
            alias: 'State',
            shortName: 'State',
            allowsMultipleValues: false,
            allowedOperators: 'ALL',
            options: transport_types_1.Pricing.USStateAbbreviations.map((state) => ({
                value: state,
                label: state,
            })),
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=sourgum-pricing-zone.js.map